<template>
  <div class="mt-10">
    <table class="table">
      <thead>
        <tr>
          <th class="text-center">Carton</th>
          <th width="150">Box Number</th>
          <th width="150" class="text-center">Consultant ID</th>
          <th class="text-center">Total</th>
          <th class="text-center">Orders</th>
        </tr>
      </thead>
      <template v-for="carton in cartons">
        <thead class="table table-bordered">
          <tr>
            <th colspan="5">
              Carton {{ carton.no }} ({{ carton.total }})
              <span v-if="carton.components"> - With Component Boxes </span>
            </th>
          </tr>

        </thead>
        <tbody :key="carton.no" class="table table-bordered">
          <template v-for="(field, boxIndex) in carton.fields">
            <tr :key="boxIndex">
              <td class="text-center">{{ carton.no }}</td>
              <td class="text-capitalize">
                <template v-if="field.type === 'shirt'">
                  {{ field.field.replace(/_/g, " ") }}
                  <span v-if="showConsultantId(field.consultant_id)">
                    - {{ field.consultant_id }}</span
                  >
                </template>
                <template v-else>
                  {{ field.item_name }}
                  <span v-if="field.consultant_id">
                    - {{ field.consultant_id }}</span
                  >
                </template>
              </td>
              <td class="text-center">
                {{ field.consultant_id }}
              </td>
              <td class="text-center">{{ field.total }}</td>
              <td>
                <template v-for="(orders, orderKey) in field.metadata">
                  <h5>{{ getOrderGroupLabel(orderKey) }}</h5>
                  <div class="itemListing">
                    {{ orders.join(", ") }}
                  </div>
                </template>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  props: ["cartons"],
  methods: {
    /**
     * show consultnat Id if more than one box exists in cartons
     * @param int consultantId
     */
    showConsultantId(consultantId) {
      let totalBoxesForInputConsultantId = 0;
      this.cartons.forEach(function (carton) {
        let boxes = carton.fields.filter(function (box) {
          return box.consultant_id == consultantId && box.name != "mixed_box";
        });
        totalBoxesForInputConsultantId += boxes.length;
      });
      return totalBoxesForInputConsultantId > 1;
    },
    /**
     * Transform the order group key in the metadata into a human-readable label.
     * @param orderType
     * @returns {string}
     */
    getOrderGroupLabel(orderType) {
      let label = orderType
      switch (orderType) {
        case 'kellerfaltenbluse_orders':
          label = 'KFB Orders'
          break;
        default:
          /**
           * Transform a string like:
           * shirt_orders => Shirt Orders
           * curly_orders => Curly Orders
           */
          label = orderType.split('_').map(string => {
            // Capitalize the first character
            return string.charAt(0).toUpperCase() + string.slice(1)
          }).join(' ');
      }
      return label;
    }
  },
};
</script>

<style>
  .itemListing {
    background: #eee;
    padding: 5px;
  }
</style>
